'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    flushUpdates = require('../utils/flushUpdates');

var PlayerActionCreators = {
  play(mediaId, options) {
    flushUpdates(() => {
      AppDispatcher.handleViewAction({
        type: ActionTypes.PLAYER_PLAY,
        mediaId: mediaId,
        options: options
      });
    });
  },

  playPrevious(mediaId) {
    flushUpdates(() => {
      AppDispatcher.handleViewAction({
        type: ActionTypes.PLAYER_PLAY_PREVIOUS,
        mediaId: mediaId
      });
    });
  },

  playNext(mediaId) {
    flushUpdates(() => {
      AppDispatcher.handleViewAction({
        type: ActionTypes.PLAYER_PLAY_NEXT,
        mediaId: mediaId
      });
    });
  },

  pause(mediaId) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PLAYER_PAUSE,
      mediaId: mediaId
    });
  },

  setCurrentTime(mediaId, time) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PLAYER_SET_CURRENT_TIME,
      mediaId: mediaId,
      time: time
    });
  },

  registerAudio(mediaId, options) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PLAYER_REGISTER_AUDIO,
      mediaId: mediaId,
      options: options
    });
  },

  unregisterAudio(mediaId) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PLAYER_UNREGISTER_AUDIO,
      mediaId: mediaId
    });
  },

  considerSetStickyMedia(mediaId, options) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PLAYER_CONSIDER_SET_STICKY_MEDIA,
      mediaId: mediaId,
      options: options
    });
  },

  considerRemoveStickyMedia(force) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PLAYER_CONSIDER_REMOVE_STICKY_MEDIA,
      force: force
    });
  }
};

module.exports = PlayerActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/PlayerActionCreators.js
 **/